"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var SharedWidgets_1 = require("../SharedWidgets");
var TabStyles_1 = require("../styles/TabStyles");
var ReactHelpers_1 = require("../utils/ReactHelpers");
var DelayStyleOverrides = Object.freeze({
    backgroundColor: TabStyles_1.TabStyles.Colors.L8,
    borderColor: TabStyles_1.TabStyles.Colors.L8,
    color: TabStyles_1.TabStyles.Colors.White
});
var AutoResetButton = /** @class */ (function (_super) {
    tslib_1.__extends(AutoResetButton, _super);
    function AutoResetButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { label: undefined };
        _this.timeoutId = undefined;
        _this.handleClick = function (e) {
            _this.setState({ label: _this.props.delayLabel });
            _this.timeoutId = window.setTimeout(_this.handleReset, _this.props.delay);
            ReactHelpers_1.safeInvoke(_this.props.handleClick, e);
        };
        _this.handleReset = function () {
            _this.timeoutId = undefined;
            _this.setState({ label: undefined });
            _this.props.handleReset();
        };
        return _this;
    }
    AutoResetButton.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.timeoutId);
    };
    AutoResetButton.prototype.render = function () {
        // tslint:disable-next-line:max-line-length
        var _a = this.props, children = _a.children, delay = _a.delay, delayLabel = _a.delayLabel, handleClick = _a.handleClick, handleReset = _a.handleReset, label = _a.label, onKeyDown = _a.onKeyDown, onKeyPress = _a.onKeyPress, onKeyUp = _a.onKeyUp, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, style = _a.style, rest = tslib_1.__rest(_a, ["children", "delay", "delayLabel", "handleClick", "handleReset", "label", "onKeyDown", "onKeyPress", "onKeyUp", "onMouseDown", "onMouseUp", "style"]);
        var interactiveEvents = { onClick: this.handleClick, onKeyDown: onKeyDown, onKeyPress: onKeyPress, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseUp: onMouseUp };
        var isPushed = !!this.state.label;
        return (React.createElement(SharedWidgets_1.ButtonWidget, tslib_1.__assign({}, rest, (!isPushed && interactiveEvents), { "aria-disabled": rest.disabled || isPushed, "aria-live": 'assertive' // aria-live tells AT to re-announce the button when the text changes (i.e. after it gets clicked)
            , style: tslib_1.__assign(tslib_1.__assign({}, style), (isPushed && DelayStyleOverrides)) }),
            this.state.label || label,
            children));
    };
    AutoResetButton.defaultProps = { delay: 5000 };
    return AutoResetButton;
}(React.PureComponent));
exports.AutoResetButton = AutoResetButton;
//# sourceMappingURL=AutoResetButtonWidget.js.map